(function () {
  function initEmberCordlockOptions(root) {
    if (!root || root.dataset.emberCordlockReady === 'true') return;
    root.dataset.emberCordlockReady = 'true';

    var form = root.closest('form') || document.querySelector('[data-product-form] form') || document.querySelector('.shopify-product-form');
    if (!form) return;

    var finishBlock = root.querySelector('[data-ember-cordlock-finish]');
    var colorBlock = root.querySelector('[data-ember-cordlock-color]');
    var colorSelect = root.querySelector('[data-ember-cordlock-color-select]');
    var propFinish = root.querySelector('[data-ember-cordlock-prop-finish]');
    var propColor = root.querySelector('[data-ember-cordlock-prop-color]');
    var propSku = root.querySelector('[data-ember-cordlock-prop-sku]');
    var variantsJsonEl = root.querySelector('[data-cordlock-variants]');

    var defaultFinish = root.getAttribute('data-default-finish') || 'Machined';
    var defaultColor = root.getAttribute('data-default-color') || 'Ø1 Schwarz Black';
    var defaultSku = root.getAttribute('data-default-sku') || 'ACTCLMSB';

    var cordlockVariants = [];
    try {
      var cordlockProduct = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : null;
      cordlockVariants = (cordlockProduct && cordlockProduct.variants) || [];
    } catch (e) {
      cordlockVariants = [];
    }

    function isCordlockSelection(value) {
      return String(value || '').toLowerCase().indexOf('cordlock') !== -1;
    }

    function getSelectionValue() {
      var checked = form.querySelector('[data-variant-option-value]:checked');
      if (checked) return checked.value;

      var select = form.querySelector('select[data-variant-option], select.single-option-selector');
      if (select && select.value && select.value !== 'not-selected') return select.value;

      var selects = form.querySelectorAll('select[data-variant-option]');
      if (selects.length) {
        var first = selects[0];
        if (first && first.value && first.value !== 'not-selected') return first.value;
      }

      return '';
    }

    function getSelectedFinish() {
      var checked = root.querySelector('[data-ember-cordlock-finish-value]:checked');
      return checked ? checked.value : '';
    }

    function getSelectedColor() {
      return colorSelect && colorSelect.value ? colorSelect.value : '';
    }

    function lookupSku(finish, color) {
      for (var i = 0; i < cordlockVariants.length; i++) {
        var variant = cordlockVariants[i];
        var options = variant.options || [];
        if (options[0] === finish && options[1] === color) {
          return variant.sku || defaultSku;
        }
      }
      return '';
    }

    function setPropsEnabled(enabled) {
      [propFinish, propColor, propSku].forEach(function (input) {
        if (!input) return;
        if (enabled) {
          input.removeAttribute('disabled');
        } else {
          input.setAttribute('disabled', 'disabled');
          input.value = '';
        }
      });
    }

    function syncProperties(applyDefaults) {
      var bundling = isCordlockSelection(getSelectionValue());
      if (!bundling) {
        setPropsEnabled(false);
        return;
      }

      var finish = getSelectedFinish();
      var color = getSelectedColor();

      if (applyDefaults) {
        if (!finish) finish = defaultFinish;
        if (!color) color = defaultColor;
      }

      var sku = '';
      if (finish && color) {
        sku = lookupSku(finish, color) || (finish === defaultFinish && color === defaultColor ? defaultSku : '');
      }

      setPropsEnabled(true);
      if (propFinish) propFinish.value = finish || '';
      if (propColor) propColor.value = color || '';
      if (propSku) propSku.value = sku || '';
    }

    function updateVisibility() {
      var bundling = isCordlockSelection(getSelectionValue());
      if (bundling) {
        root.hidden = false;
        root.classList.add('is-visible');
        if (finishBlock) finishBlock.hidden = false;

        var finish = getSelectedFinish();
        if (colorBlock) {
          colorBlock.hidden = !finish;
        }
      } else {
        root.hidden = true;
        root.classList.remove('is-visible');
        if (finishBlock) {
          var radios = root.querySelectorAll('[data-ember-cordlock-finish-value]');
          for (var i = 0; i < radios.length; i++) radios[i].checked = false;
        }
        if (colorSelect) colorSelect.value = '';
        if (colorBlock) colorBlock.hidden = true;
      }
      syncProperties(false);
    }

    form.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      if (
        target.matches('[data-variant-option-value]') ||
        target.matches('select[data-variant-option]') ||
        target.matches('select.single-option-selector')
      ) {
        updateVisibility();
        return;
      }

      if (target.matches('[data-ember-cordlock-finish-value]')) {
        if (colorBlock) colorBlock.hidden = false;
        syncProperties(false);
        return;
      }

      if (target.matches('[data-ember-cordlock-color-select]')) {
        syncProperties(false);
      }
    });

    form.addEventListener('submit', function () {
      syncProperties(true);
    }, true);

    form.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest('[data-add-to-cart-trigger], .button--add-to-cart, [name="add"]');
      if (btn) syncProperties(true);
    }, true);

    updateVisibility();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ember-cordlock-options]');
    for (var i = 0; i < nodes.length; i++) {
      initEmberCordlockOptions(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
